import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  enableProdMode,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalService } from '@azure/msal-angular';
import { AppInsightsService, bootstrap, ErrorHandlerService, ErrorInterceptor, MSALRedirectFactory } from '@ct/data';
import { NAVIGATION, PROJECT_PREFIX } from '@ct/model';
import { CtDateAdapter, DATE_FORMATTER } from '@ct/shared';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { ConfirmService } from '@ngx-stoui/common';
import { AppComponent } from './app/app.component';
import { reducers } from './app/store';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrap(Number(window.location.port), '', !environment.production).then((msalProviders) =>
  bootstrapApplication(AppComponent, {
    providers: [
      ...msalProviders,
      AppInsightsService,
      ConfirmService,
      MsalBroadcastService,
      MsalBroadcastService,
      MsalGuard,
      MsalService,
      { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
      { provide: PROJECT_PREFIX, useValue: '' },
      { provide: NAVIGATION, useValue: [] },
      { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATTER },
      { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
      { provide: DateAdapter, useClass: CtDateAdapter },
      { provide: ErrorHandler, useClass: ErrorHandlerService },
      provideAnimations(),
      provideAppInitializer(() => {
        const initializerFn = MSALRedirectFactory(
          inject(MsalService),
          inject(HttpClient),
          inject(MsalBroadcastService),
        );
        return initializerFn();
      }),
      provideEffects([]),
      provideHttpClient(withInterceptorsFromDi()),
      provideRouter(
        [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./app/home/home.component').then((c) => c.HomeComponent),
          },
          { path: 'admin', loadComponent: () => import('./app/admin/admin.component').then((c) => c.AdminComponent) },
        ],
        withComponentInputBinding(),
        withViewTransitions(),
      ),
      provideStore(reducers, {
        metaReducers: [],
        runtimeChecks: { strictStateImmutability: true, strictActionImmutability: true },
      }),
      !environment.production ? provideStoreDevtools({ maxAge: 50, connectInZone: true }) : [],
      provideZonelessChangeDetection(),
    ],
  }).catch((err) => console.error(err)),
);
